import { HeldRemoteLeft, HeldRemoteRight } from "../bit-components";
import { anyEntityWith } from "../utils/bit-utils";
import { findRemoteHoverTarget } from "./cursor-controller";

AFRAME.registerComponent("artwork-toggler-menu", {
  init() {
    this.mouseDownTime = 0;
    this.isGrabbing = false;
    this.movementThreshold = 5; // Define a threshold for movement to detect dragging

    // Track initial mouse position
    this.startX = 0;
    this.startY = 0;
    this.interaction = this.interaction || window.APP.scene.systems.interaction;

    // Add general window onclick event listener
    window.onmousedown = event => {
      // Store the start time and position
      this.mouseDownTime = Date.now();
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.isGrabbing = false;

      const entity = anyEntityWith(APP.world, HeldRemoteLeft) || anyEntityWith(APP.world, HeldRemoteRight);
    };

    // Add general window onmouseup event listener
    window.onmouseup = event => {
      let hasDrawerOpen = false;

      // Quick return if the clicked element is not a canvas element
      if (event.target.tagName !== "CANVAS") return;

      document.querySelectorAll(".fui-OverlayDrawer").forEach(drawer => {
        // let leftPositioning = parseInt(window.getComputedStyle(drawer, null).getPropertyValue("left"));
        // if(leftPositioning < 0) {
        //   hasDrawerOpen = true;
        // }
        if (drawer) {
          hasDrawerOpen = true;
        }
      });

      if (event.button != 0) return;
      // const entity = anyEntityWith(APP.world, HeldRemoteLeft) || anyEntityWith(APP.world, HeldRemoteRight);
      const PinnedIntersection =
        document.getElementById("left-cursor-controller").components["cursor-controller"]?.intersection ||
        document.getElementById("right-cursor-controller").components["cursor-controller"]?.intersection;
      const PinnedEntity = PinnedIntersection && findRemoteHoverTarget(APP.world, PinnedIntersection.object);

      const entity =
        PinnedEntity || anyEntityWith(APP.world, HeldRemoteLeft) || anyEntityWith(APP.world, HeldRemoteRight);

      const duration = Date.now() - this.mouseDownTime;

      // Calculate the movement distance
      const deltaX = event.clientX - this.startX;
      const deltaY = event.clientY - this.startY;
      const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

      // Check if it's a grab or a click based on duration and movement
      if (duration > 400 || distance > this.movementThreshold) {
        // Considered a grab
        this.isGrabbing = true;
        // Custom logic for grab
      } else {
        // Considered a click
        this.isGrabbing = false;
        const hoverEl = APP.world.eid2obj.get(entity)?.el;
        // const hoverEl = this.interaction.state.rightRemote.hovered || this.interaction.state.leftRemote.hovered;

        if (hoverEl && hoverEl.components["artwork"]) {
          window.APP.scene.systems["hubs-systems"].cameraSystem.inspectArtwork(hoverEl, 1.5);
          window.dispatchEvent(new CustomEvent("open-artwork-info", { detail: hoverEl }));
        }
        // Custom logic for click
      }
    };
  }
});
